import React from 'react';
import { useGlobalContext } from '../context';
const CartItem = ({ _id, productId, qty }) => {
  const { remove, toggleAmount } = useGlobalContext();
  let price = productId.price;
  price = parseFloat(price.toFixed(2));
  price = price.toLocaleString('en');

  return (
    <article className='cart-item'>
      <img src={productId.image} alt={productId.name} />
      <div>
        <h4>{productId.name}</h4>
        <h4 className='item-price'>Php {price}</h4>
        {/* remove button */}
        <button className='remove-btn' onClick={() => remove(_id)}>
          remove
        </button>
      </div>
      <div>
        {/* increase amount */}
        <button className='amount-btn' onClick={() => toggleAmount(_id, 'inc')}>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
            <path d='M10.707 7.05L10 6.343 4.343 12l1.414 1.414L10 9.172l4.243 4.242L15.657 12z' />
          </svg>
        </button>
        {/* amount */}
        <p className='amount'>{qty}</p>
        {/* decrease amount */}
        <button className='amount-btn' onClick={() => toggleAmount(_id, 'dec')}>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
            <path d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z' />
          </svg>
        </button>
      </div>
    </article>
  );
};

export default CartItem;
